import { Component } from '@verndale/core';
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide-core.min.css';

class RelatedFactSheetCarousel extends Component {
  public relatedFactSheetCarousel: Splide;

  constructor(el: HTMLElement) {
    super(el);
    this.relatedFactSheetCarousel = {} as Splide;
    this.initSplide();
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      pagination: this.el.querySelector<HTMLElement>(
        '.related-fact-sheet-carousel__slider-pagination'
      ),
      prevButton: this.el.querySelector<HTMLElement>('.btn-previous-slide'),
      nextButton: this.el.querySelector<HTMLElement>('.btn-next-slide')
    };
    this.initSplide();
  }

  addListeners() {
    this.relatedFactSheetCarousel.on('move', this.updatePagination.bind(this));
  }

  initSplide() {
    this.relatedFactSheetCarousel = new Splide(this.el as HTMLElement, {
      type: 'slide',
      perPage: 4,
      focus: 0,
      trimSpace: false,
      perMove: 1,
      gap: 48,
      pagination: false,
      arrows: true,
      breakpoints: {
        768: {
          perPage: 1,
          gap: 16,
        },
        1280: {
          perPage: 3,
          gap: 24,
        }
      },
      reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
      },
    }).mount();

    this.updatePagination(0);
  }

  updatePagination(index: number) {
    if (this.dom.pagination) {
      const totalSlides = this.relatedFactSheetCarousel.Components.Slides.getLength();
      const totalPages = Math.ceil(totalSlides / this.relatedFactSheetCarousel.options.perMove!);
      const currentPage = Math.ceil(index / this.relatedFactSheetCarousel.options.perMove!) + 1;
      (this.dom.pagination as HTMLElement).textContent = `${currentPage} / ${totalPages}`;
    }
  }
}

export default RelatedFactSheetCarousel;
